var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateView',[_c('div',{staticClass:"container"},[_c('TemplatePageGrid',{attrs:{"items":_vm.freeDocumentsGroupsGrid,"page-data":_vm.pageData,"loading":_vm.loadingAnimation,"pagination":_vm.requestType === 'admin'},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [(
            _vm.$userCheckAccess({
              abilities: 'edit_free_documents',
            })
          )?_c('DocumentsGroupModal',{attrs:{"create":"","functionDownloadPageData":_vm.downloadPageData}}):_vm._e()]},proxy:true}])},[_c('DocumentsGroupTable',{attrs:{"items":_vm.freeDocumentsGroupsGrid,"functionDownloadPageData":_vm.downloadPageData}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }